<template>
  <!-- 提示 -->
  <el-dialog
    width="460px"
    title="认证提示"
    :visible="visible"
    :close-on-click-modal="false"
    @close="no"
  >
    <div v-if="flag === 1" class="box-content">
      <p>请尽快补充资质完成 <span>实名认证</span>！</p>
      <p>进行个人实名认证或企业资质认证通过后，您可更好地使用平台功能。</p>
    </div>
    <div v-if="flag === 2" class="box-content">
      <p>请尽快补充资质完成 <span>企业认证</span>！</p>
      <p>进行企业认证资质通过后，您可更好地使用平台功能。</p>
    </div>
    <div v-if="flag === 3" class="box-content">
      <p>请尽快补充资质完成 <span>服务商认证</span>！</p>
      <p>进行服务商认证资质通过后，您可更好地使用平台功能。</p>
    </div>
    <div slot="footer" class="btn btn-box">
      <p class="btn-com btn-gray" @click="no">暂不认证</p>
      <p
        class="btn-com btn-blue"
        @click="yes"
        style="margin-right: 0"
      >
        前往认证
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    // 1: 个人认证  2：企业认证  3：服务商认证
    flag: {
      type: Number,
      default: 2
    }
  },
  methods: {
    no() {
      this.$emit("no", false);
    },
    yes() {
      this.$emit("yes", true);
    },
  },
};
</script>

<style lang="less" scoped>
.box-content {
  padding: 6px 21px;
  p {
    font-size: 12px;
    line-height: 24px;
    span {
      color: #e14d3f;
    }
  }
}
.btn-box {
  align-items: center;
  justify-content: center;
  display: flex;
  .btn-gray {
    background: #e9f2fd;
    color: #2a86f4;
  }
  .btn-gray:hover {
    color: #004eac;
  }
}

.btn-com {
  cursor: pointer;
  width: 120px;
  height: 40px;
  background: #2a86f4;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  margin-right: 30px;
}
</style>